import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { Provider } from 'react-redux';
import { StyleProvider } from '@ant-design/cssinjs';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/theme.css';
import 'antd/dist/reset.css';
import App from 'pages/App';
import store from 'store';
import { ThemeProvider, useTheme } from 'contexts/ThemeContext';

const container = document.getElementById('root');
const root = createRoot(container);

const ThemedConfigProvider = ({ children }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
          fontSize: 14,
          borderRadius: 10,
          colorPrimary: '#ff6b35',
          colorSuccess: '#10b981',
          colorWarning: '#f59e0b',
          colorError: '#ef4444',
          colorInfo: '#3b82f6',
          colorBgContainer: isDark ? '#1a1a1a' : '#ffffff',
          colorBgElevated: isDark ? '#1a1a1a' : '#ffffff',
          colorBgLayout: isDark ? '#000000' : '#f5f7fa',
          colorBorder: isDark ? '#2d2d2d' : '#e5e7eb',
          colorText: isDark ? '#ffffff' : '#000000',
          colorTextSecondary: isDark ? '#e5e5e5' : '#1a1a1a',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider>
        <ThemedConfigProvider>
          <StyleProvider hashPriority="high">
            <App />
          </StyleProvider>
        </ThemedConfigProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
